





























import { Vue, Component, Prop } from 'vue-property-decorator'
import { XDialog } from '@lx-frontend/cvux'

@Component({
  components: {
    XDialog
  }
})
export default class Alert extends Vue {
  @Prop(String) readonly title!: string
  @Prop(String) readonly confirmText!: string

  show = false

  changeShow(v: boolean) {
    this.show = v
  }

  onConfirm() {
    this.show = false
    this.$emit('onConfirm')
  }
}
